import { colorConstants } from 'config/colorConstants';

//Figma: Global Filter V2 selection card > Button Close
const CloseFilled = ({ fill = colorConstants.filterV2IconMuted }: { fill?: string }) => (
    <svg width="12" height="12" viewBox="0 0 12.35 12.35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.313 0L12.346 1.033L7.207 6.173L12.346 11.313L11.313 12.346L6.173 7.208L1.034 12.346L0 11.313L5.139 6.173L0 1.033L1.034 0L6.173 5.139Z"
            fill={fill}
        />
    </svg>
);

export default CloseFilled;
